module.exports = __webpack_public_path__ + "static/media/fruit-pealing.5e9f8279.jpeg";